import * as S from './VariableSetSelector.styled';

const AddVariableSet = () => {
  return (
    <S.AddVarsContainer>
      <S.AddVarsIcon />
      Create variable set
    </S.AddVarsContainer>
  );
};

export default AddVariableSet;
